var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandyCane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.5 91.1C469.6 33.12 411.8 0 352.4 0c-27.88 0-56.14 7.25-81.77 22.62L243.1 38.1C227.9 48.12 223 67.75 232.1 82.87l32.76 54.87c9.375 15.75 29.38 19.94 43.88 11.06l27.51-16.37c36-21.5 69.6 33.02 32.85 54.9L15.6 397.6c-15.25 9.125-20.13 28.62-11 43.87l32.76 54.87C43.35 506.4 53.97 512 64.85 512c5.625 0 11.27-1.507 16.39-4.507l347.4-206.5C500.2 258.1 533.2 167.5 497.5 91.1zM292.2 121.4l-32.75-54.88C291.7 47.25 312.6 32.12 351.1 32v64C328.3 96.25 314.7 108.1 292.2 121.4zM383.2 104h.75V36.12c36.75 9.125 67.75 34 84.63 69.5c3.375 7.125 6 14.62 7.875 22.25h-68.5c-.25-.25-.25-.5643-.375-.8143C401.7 117.2 393.2 109.4 383.2 104zM256.7 291.4l82.38-48.1l64.25 36.25l-82.25 49L256.7 291.4zM289.3 346.5l-87.5 52l-64.25-36.25l87.5-52L289.3 346.5zM64.72 480l-32.88-54.88l73.88-43.88l64.38 36.13L64.72 480zM432.7 258.5l-62-34.88l14.63-8.75C405.4 203 416.2 181.8 416.2 160h63C478.4 196.5 462.1 232.8 432.7 258.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyCane);
export default __webpack_public_path__ + "static/media/candy-cane.f07cdbe1c2b0f9a4cf36209b231b9e0e.svg";
export { ForwardRef as ReactComponent };